module.exports = __webpack_public_path__ + "front/img/30.2d5c4544.png";